<app-fullscreen-loading
    *ngIf="global.getFullLoading()"></app-fullscreen-loading>
<div class="w-full bg-lightBG dark:bg-darkBG tracking-normal ">
    <app-header></app-header>
    <!-- <div *ngIf="getErrorServerStatus().status" class="min-h-screen">
        <app-error [imgName]="getErrorServerStatus().errorObj.img" [errorContent]="getErrorServerStatus().errorObj.message"></app-error>
    </div> -->
    <main class="min-h-main">
        <div id="main" class="main-container relative landing">
            <section class="block">
                <router-outlet></router-outlet>
            </section>
        </div>
    </main>
    <app-footer></app-footer>
</div>